// @flow

import * as R from "ramda";

import type {
  ChecklistFieldType,
  LinkedFieldType,
  chatPickListField,
  TaskField,
  GroupField,
  workflowField,
  ChecklistFieldTypes
} from "src/types";

const createBasicHandler = type => ({
  tag: (v: ChecklistFieldType, h: Function) => type,
  rep: (v: ChecklistFieldType, h: Function) => ({
    label: v.label,
    importError: v.importError,
    autoCheck: v.autoCheck,
    settings: v.settings,
    excludeFromCollapse: v.excludeFromCollapse
  }),
  stringRep: (v: ChecklistFieldType, h: Function) => v.label
});

const textHandler = createBasicHandler("text");
const richTextHandler = createBasicHandler("richtext");
const numberHandler = createBasicHandler("number");
const dateHandler = createBasicHandler("date");
const userHandler = createBasicHandler("user");
const conversationHandler = createBasicHandler("conversation");
const childConversationHandler = {
  tag: (v: ChecklistFieldType, h: Function) => "conversation",
  rep: (v: ChecklistFieldType, h: Function) => {
    return {
      label: v.label,
      importError: v.importError,
      autoCheck: v.autoCheck,
      settings: !R.isEmpty(v.settings)
        ? JSON.stringify({ ...JSON.parse(v.settings), child: true })
        : JSON.stringify({ child: true }),
      excludeFromCollapse: v.excludeFromCollapse
    };
  },
  stringRep: (v: ChecklistFieldType, h: Function) => v.label
};
const selectHandler = createBasicHandler("select");
const formHandler = createBasicHandler("form");

export const pdfHandler = createBasicHandler("pdf");
export const sectionHandler = createBasicHandler("section");

const subSectionHandler = {
  tag: (v: ChecklistFieldType, h: Function) => "section",
  rep: (v: ChecklistFieldType, h: Function) => {
    return {
      label: v.label,
      importError: v.importError,
      autoCheck: v.autoCheck,
      settings: !R.isEmpty(v.settings)
        ? JSON.stringify({ ...JSON.parse(v.settings), level: 1 })
        : JSON.stringify({ level: 1 })
    };
  },
  stringRep: (v: ChecklistFieldType, h: Function) => v.label
};

export const fileHandler = createBasicHandler("file");
export const aiHandler = createBasicHandler("ai");

// Old Transit Writer
export const chatPickListHandler = {
  tag: (v: chatPickListField, h: Function) => "chatPickList",
  rep: (v: chatPickListField, h: Function) => ({
    label: v.label,
    importError: v.importError,
    isRequired: v.isRequired,
    placeholder: v.placeholder,
    isChecked: v.isChecked,
    settings: v.settings
  }),
  stringRep: (v: chatPickListField, h: Function) => v.label
};

export const taskHandler = {
  tag: (v: TaskField, h: Function) => "task",
  rep: (v: TaskField, h: Function) => ({
    label: v.label,
    importError: v.importError,
    isRequired: v.isRequired,
    placeholder: v.placeholder,
    isChecked: v.isChecked
  }),
  stringRep: (v: TaskField, h: Function) => v.label
};

export const groupHandler = {
  tag: (v: GroupField, h: Function) => "group",
  rep: (v: GroupField, h: Function) => ({
    label: v.label,
    importError: v.importError,
    isRequired: v.isRequired,
    placeholder: v.placeholder,
    isChecked: v.isChecked
  }),
  stringRep: (v: GroupField, h: Function) => v.label
};

export const workflowHandler = {
  tag: (v: workflowField, h: Function) => "workflow",
  rep: (v: workflowField, h: Function) => ({
    label: v.label,
    importError: v.importError,
    isRequired: v.isRequired,
    placeholder: v.placeholder,
    isChecked: v.isChecked,
    settings: v.settings
  }),
  stringRep: (v: workflowField, h: Function) => v.label
};

export const approvalHandler = {
  tag: (v: ChecklistFieldType, h: Function) => "approval",
  rep: (v: ChecklistFieldType, h: Function) => ({
    label: v.label,
    importError: v.importError,
    autoCheck: v.autoCheck,
    settings: v.settings,
    excludeFromCollapse: v.excludeFromCollapse
  }),
  stringRep: (v: ChecklistFieldType, h: Function) => v.label
};

export const revisionHandler = {
  tag: (v: ChecklistFieldType, h: Function) => "revision",
  rep: (v: ChecklistFieldType, h: Function) => ({
    label: v.label,
    importError: v.importError,
    autoCheck: v.autoCheck,
    settings: v.settings
  }),
  stringRep: (v: ChecklistFieldType, h: Function) => v.label
};

export const linkHandler = {
  tag: (v: LinkedFieldType, h: Function) => "link",
  rep: (v: LinkedFieldType, h: Function) => ({
    label: v.label,
    importError: v.importError,
    autoCheck: v.autoCheck,
    settings: v.settings,
    sourceProcessSettings: v.sourceProcessSettings,
    linkedProcessSettings: v.linkedProcessSettings,
    excludeFromCollapse: v.excludeFromCollapse
  }),
  stringRep: (v: LinkedFieldType, h: Function) => v.label
};

const transitHandlers: { [ChecklistFieldTypes]: Object } = {
  text: textHandler,
  number: numberHandler,
  section: sectionHandler,
  subSection: subSectionHandler,
  date: dateHandler,
  user: userHandler,
  file: fileHandler,
  conversation: conversationHandler,
  childConversation: childConversationHandler,
  select: selectHandler,
  chatPickList: chatPickListHandler,
  task: taskHandler,
  workflow: workflowHandler,
  group: groupHandler,
  pdf: pdfHandler,
  form: formHandler,
  approval: approvalHandler,
  revision: revisionHandler,
  link: linkHandler,
  richtext: richTextHandler,
  ai: aiHandler
};

export default transitHandlers;
